export const SITUACAO = {
  A: "Ativo",
  C: "Cancelado",
  S: "Suspenso",
  P: "Em processo de Cadastramento",
};
